import React from 'react';


class ArticleFilterPane extends React.Component {
  
  constructor(props) {
    super(props);

    this.state = {
      showFilters: false,
      activeFilters: []
    };

    this.handleFilterChange = this.handleFilterChange.bind(this)
    this.toggleFilters = this.toggleFilters.bind(this)
  }

  toggleFilters() {
    this.setState({
      showFilters: !this.state.showFilters
    })
  }

  handleFilterChange(field, target, subfield) {
     
    if (this.props.busy) return;

    if (target !== undefined && subfield === undefined)
      return this.props.onFilterChange(target, field.target.value);

    // update subfield value
    if (subfield !== undefined) {
      field[target].map((row) => {
        if (row.id === subfield.id) {
          row.value = !row.value;
        }
        return row;
      })
    }
    
    var updatedFilter = this.props?.filters.map((row) => {
      if (subfield !== undefined)
        return (row.id === field.id) ? field : row;
      else
        return (row.id === field.id) ? {...row, value: !field.value} : row;
    })

    // update filter value
    this.props.onFilterChange('filter', updatedFilter)
    
  }

  render() {

    return (
      <React.Fragment>
        <div className={`cs-daily-posts-filters${this.props.busy?' cs-daily-posts-filters--busy':''}`}>
          <div className="cs-accordion">
            <button className={`cs-accordion__toggle${this.state.showFilters?' collapsed':''}`} aria-expanded={this.state.showFilters} onClick={this.toggleFilters} type="button">Filters</button>
            <div className={`collapse${this.state.showFilters?' show':''}`}>
              <div className="cs-accordion__content">

                    <div className="cs-daily-posts-filter">

                      <h3 className="cs-daily-posts-filter__title">Content From:</h3>
                      <div className="cs-daily-posts-filter__options">
                        <div className="cs-daily-posts-filter__option">
                          {
                            this.props?.filters.map((item, index) => (
                              <div key={index} className="custom-control custom-switch custom-switch--reverse">
                                <input
                                  type="checkbox"
                                  checked={item.value}
                                  onChange={()=>{this.handleFilterChange(item)}}
                                  className="custom-control-input"
                                />
                                <label
                                  className="custom-control-label"
                                >
                                  {item.label}
                                </label>
                                <div className="custom-control-nested">
                                  {
                                    item?.value === true && item.hasOwnProperty('authors') ?
                                    item?.authors.map((author, index) => (
                                      <div key={index} className="custom-control custom-switch custom-switch--reverse">
                                        <input
                                          type="checkbox"
                                          onChange={()=>{this.handleFilterChange(item, 'authors', author)}}
                                          checked={author.value}
                                          className="custom-control-input"
                                        />
                                        <label
                                          className="custom-control-label"
                                        >
                                          {author.label}
                                        </label>
                                      </div>
                                    ))
                                    : null
                                  }
                                </div>
                              </div>
                            ))
                          }
                        </div>
                      </div>
                      {
                        this.props.sortby?([
                          <h3 key={0} className="cs-daily-posts-filter__title">Sort by:</h3>,
                          <div key={1} className="cs-daily-posts-filter__options">
                            <div className="cs-daily-posts-filter__option">
                              <select defaultValue={this.props?.sortByValue} onChange={(event)=>{this.handleFilterChange(event, 'sortby')}}>
                                {
                                  this.props?.sortby.map((item, index) => (
                                    <option key={index} value={item.value}>{item.label}</option>
                                  ))
                                }
                              </select>
                              <select defaultValue={this.props?.sortValue} onChange={(event)=>{this.handleFilterChange(event, 'sort')}}>
                                <option value="desc">Descending</option>
                                <option value="asc">Ascending</option>
                              </select>
                            </div>
                          </div>
                        ]):null
                      }
                    </div>
                    
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default ArticleFilterPane;

